import type { ResourceWithSlug } from "./ResourceWithSlug";
import type { NamedResource } from "./namedResource";
import type { SensitiveValue } from "./propertyValueResource";
import type { SpaceScopedResource } from "./spaceScopedResource";
import type { TenantedDeploymentMode } from "./tenantedDeploymentMode";
export enum AccountType {
    None = "None",
    UsernamePassword = "UsernamePassword",
    Token = "Token",
    SshKeyPair = "SshKeyPair",
    AzureSubscription = "AzureSubscription",
    AzureServicePrincipal = "AzureServicePrincipal",
    AzureManagementCertificate = "AzureManagementCertificate",
    AzureOidc = "AzureOidc",
    AmazonWebServicesAccount = "AmazonWebServicesAccount",
    AmazonWebServicesOidcAccount = "AmazonWebServicesOidcAccount",
    GoogleCloudAccount = "GoogleCloudAccount"
}
interface AccountResourceLinks {
    Self: string;
    Usages: string;
}
export interface AccountResource extends NamedResource<AccountResourceLinks>, ResourceWithSlug, SpaceScopedResource {
    Name: string;
    Description: string;
    EnvironmentIds: string[];
    TenantIds: string[];
    TenantTags: string[];
    AccountType: AccountType;
    TenantedDeploymentParticipation: TenantedDeploymentMode;
}
export interface AzureServicePrincipalAccountResource extends AccountResource {
    SubscriptionNumber: string;
    ClientId: string;
    TenantId: string;
    Password: SensitiveValue;
    AzureEnvironment: string;
    ResourceManagementEndpointBaseUri: string;
    ActiveDirectoryEndpointBaseUri: string;
}
export interface AzureOidcAccountResource extends AccountResource {
    SubscriptionNumber: string;
    ClientId: string;
    TenantId: string;
    AzureEnvironment: string;
    TenantedSubjectGeneration: boolean;
    ResourceManagementEndpointBaseUri: string;
    ActiveDirectoryEndpointBaseUri: string;
    DeploymentSubjectKeys: string[];
    HealthCheckSubjectKeys: string[];
    AccountTestSubjectKeys: string[];
    Audience: string;
}
export interface AzureSubscriptionAccountResource extends AccountResource {
    SubscriptionNumber: string;
    CertificateBytes: SensitiveValue;
    CertificateThumbprint: string;
    AzureEnvironment: string;
    ServiceManagementEndpointBaseUri: string;
    ServiceManagementEndpointSuffix: string;
}
export interface SshKeyPairAccountResource extends AccountResource {
    Username: string;
    PrivateKeyFile: SensitiveValue;
    PrivateKeyPassphrase: SensitiveValue;
}
export interface UsernamePasswordAccountResource extends AccountResource {
    Username: string;
    Password: SensitiveValue;
}
export interface TokenAccountResource extends AccountResource {
    Token: SensitiveValue;
}
export interface AmazonWebServicesAccessKeyAccountResource extends AccountResource {
    AccessKey: string;
    SecretKey: SensitiveValue;
}
export interface AmazonWebServicesOidcAccountResource extends AccountResource {
    RoleArn: string;
    SessionDuration: string;
    DeploymentSubjectKeys: string[];
    HealthCheckSubjectKeys: string[];
    AccountTestSubjectKeys: string[];
}
export interface GoogleCloudAccountResource extends AccountResource {
    JsonKey: SensitiveValue;
}
